import en from '../strings/lang/en';
var settlementPlan = 'settlement plan';
export var settlement = 'settlement';
export var dchSettlement = 'dch settlement';
export var settlementAnalytics = {
    settlementStart: { pageFunction: settlementPlan, pageName: 'start' },
    settlementOptions: {
        pageFunction: settlementPlan,
        pageName: 'plan selection'
    },
    S001: {
        pageFunction: settlementPlan,
        pageName: 'questionnaire',
        pageSubFunction: 'reason'
    },
    S002: {
        pageFunction: settlementPlan,
        pageName: 'questionnaire',
        pageSubFunction: 'primary source'
    },
    settlementPlanReview: {
        pageFunction: settlementPlan,
        pageName: 'review',
        message: en.common.confirmEnrollBannerText
    },
    settlementPlanSuccess: {
        pageFunction: settlementPlan,
        pageName: 'enrollment success',
        message: en.settlement.successHeading
    },
    settlementOtherPaymentOptions: {
        pageFunction: settlementPlan,
        pageName: 'not eligible',
        message: en.settlement.contactHeading
    },
    planError: {
        pageFunction: settlementPlan,
        pageName: 'error',
        errorMessage: en.common.errorHeading
    },
    leaving: {
        pageFunction: settlementPlan,
        pageName: 'not eligible:exit confirmation',
        errorMessage: en.settlement.contactHeading
    }
};
//# sourceMappingURL=settlementAnalytics.js.map